import { Color } from '@diritto/common/style/color';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { CheckBoxIcon } from 'icons/CheckBoxIcon';
import { HTMLProps } from 'react';

interface CheckBoxProps extends HTMLProps<HTMLInputElement> {
  id?: string;
  children: React.ReactNode;
  className?: string;
}

export const ResizableCheckBox = ({ id, className, checked, onChange, size = 16, children }: CheckBoxProps) => (
  <CheckBoxWrapper>
    <ResizableCheckBoxIcon checked={checked} size={size} />
    <StyledButton id={id} className={className} type="checkbox" checked={checked} onChange={onChange} />
    <StyledBodyWrapper>{children}</StyledBodyWrapper>
  </CheckBoxWrapper>
);

const CheckBoxWrapper = styled.label`
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
`;

const ResizableCheckBoxIcon = styled(CheckBoxIcon)(
  ({ checked, size }: { checked?: boolean; size?: number }) => css`
    border: 1px solid ${checked ? 'transparent' : Color.Gray400};
    border-radius: 3px;
    margin-right: 8px;
    width: ${size}px;
    height: ${size}px;
  `,
);

const StyledButton = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
`;

const StyledBodyWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
`;
